import { Checkbox, CheckboxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

const Icon = styled('span')<any>(({ theme, invalid, disabled }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '3px',
  // eslint-disable-next-line no-nested-ternary
  border: invalid
    ? `2px solid ${theme.palette.error.main}`
    : disabled
    ? '1px solid #cccccc'
    : '1px solid #7B849D',
  margin: '2px',
  boxSizing: 'border-box',
  background: disabled ? '#cccccc' : 'none'
}))

const CheckedIcon = styled('span')<any>(({ theme, invalid, disabled }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '3px',
  background: disabled
    ? 'center no-repeat url("/icons/check.svg"), #cccccc'
    : `center no-repeat url("/icons/check.svg"), ${theme.palette.secondary.main}`,
  margin: '2px',
  boxSizing: 'border-box',
  border: invalid ? `2px solid ${theme.palette.error.main}` : 'none'
}))

const BelugaCheckbox = ({
  invalid,
  ...props
}: CheckboxProps & { invalid?: boolean }): JSX.Element => {
  return (
    <Checkbox
      icon={<Icon disabled={props.disabled} invalid={invalid} />}
      checkedIcon={<CheckedIcon disabled={props.disabled} invalid={invalid} />}
      {...props}
    />
  )
}

export default BelugaCheckbox
